import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationContractNotFoundError = BaseErrorSchema.extend({
  errorType: z.literal('OrganizationContractNotFoundError'),
  id: z.string(),
});

export type OrganizationContractNotFoundError = z.infer<
  typeof OrganizationContractNotFoundError
>;
